import { ValidatorFn, FormGroup } from '@angular/forms';

export const checkPasswords: ValidatorFn | any = (formGroup: FormGroup) => {
  const first = formGroup.contains('newPassword')
    ? formGroup.get('newPassword')?.value
    : formGroup.get('password')?.value;
  const second = formGroup.get('retypedPassword')?.value;

  if (!second || second.length === 0) {
    return null;
  }

  const checkIsEqual = first === second;
  const firstControl = formGroup.contains('newPassword')
    ? formGroup.get('newPassword')
    : formGroup.get('password');

  let errors = firstControl?.errors || {};
  const totalErros = Object.values(errors).length;

  if (!checkIsEqual && totalErros === 0) {
    errors.passwordsNotSame = true;
    firstControl?.setErrors(errors);
  }

  if (checkIsEqual && totalErros > 0) {
    firstControl?.updateValueAndValidity({onlySelf: true});
  }

  if (checkIsEqual && totalErros === 0) {
    delete errors.passwordsNotSame;
    firstControl?.setErrors(null);
  }

  return checkIsEqual ? null : { passwordsNotSame: true };
};
